import type { CommonPendingInfo, NotificationData } from '../types';
///办理专员html
const handleHtml = `
  <p>
    <div  class="flex  flex-col">
      <div class="font-bold">专属办理专员：</div>
      <div><font color='red'>姓名：</font> {{userName}}</div>
      <div><font color='red'>联系方式：</font> {{userPhone}}</div>
    </div>
  </p>
`;
// 专属办理专员html
const handleHtmlV2 = `
  <p>
   <div class="font-bold">专属办理专员：黄专员 18929129727</div>
  </p>
`;
// 总部投诉html
const complaintHtml = `
  <p>
    <div class="font-bold">总部咨询电话：13049806760</div>
    <div class="font-bold">总部投诉电话：18112607321</div>
  </p>
`;
// 固定专员html
const fixedHtml = `
  <p>
    <div class="font-bold">专属办理专员：黄专员 18929129727</div>
  </p>
`;

export function getAnnualInspectionData(): CommonPendingInfo {
  const title = '工商年检待办';
  const data: NotificationData = {
    title,
    type: 'rich_text',
    content: `
    <div class="flex items-center mb-4">
      <div class="flex-shrink-0">
        <div class="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
          <img src="https://unpkg.com/lucide-static@latest/icons/clipboard-list.svg" class="w-6 h-6 text-white" alt="" />
        </div>
      </div>
      <div class="flex-1 ml-4">
        <h4 class="text-base font-semibold">工商年检</h4>
      </div>
    </div>
    <div class='space-y-4 text-gray-700'>
      <p>当前需要进行工商年检报送，请经营者主动与年检办理专员联系，并配合操作。</p>
      ${fixedHtml.replace('专属', '年检')}
      ${complaintHtml}
    </div>`,
    actions: [{ label: '查看年报详情', key: 'internal-link-url', type: 'primary', url: '/annual-report-detail?year=2025' }],
  };
  return {
    data,
    title,
  };
}
export function replaceTpl(str: string, data: any): string {
  return str.replace(/{{(\w+)}}/g, (_, key) => data[key] || '');
}
// 格式化月份列表
export function formatMonthList(str: string): string {
  if (!str) return '';
  // 中文季度映射
  const quarterMap: Record<string, string> = {
    1: '第一季度',
    2: '第二季度',
    3: '第三季度',
    4: '第四季度',
  };
  return (
    str
      .split(',')
      .filter((item) => {
        // 2. 必须是 6 位纯数字
        if (item.length !== 6 || !/^\d+$/.test(item)) return false;
        const month = item.slice(4);
        return +month >= 1 && +month <= 12; // 合法月份 1-12
      })
      .map((item) => ({
        fullStr: item,
        year: item.slice(0, 4),
        month: item.slice(4),
        quarter: Math.ceil(+item.slice(4) / 3),
      }))
      // 排序：最新年度 + 最新季度 排在前面（倒序）
      .sort((a, b) => {
        if (a.year !== b.year) {
          return +a.year - +b.year;
        }
        return +a.quarter - +b.quarter;
      })
      // 转成中文格式：2025年第一季度
      .map((item) => {
        console.log('申报', item);

        return `${item.year}年${quarterMap[item.quarter]}`;
      })
      .join('、')
  );
}
// 格式化季度列表 2025-1 2025-2 2025-3 2025-4
export function formatQuarterList(str: string): string {
  if (!str) return '';
  // 中文季度映射
  const quarterMap: Record<string, string> = {
    1: '第一季度',
    2: '第二季度',
    3: '第三季度',
    4: '第四季度',
  };
  return [
    ...new Set(
      str
        .split(',')
        .map((item) => item.trim())
        .filter((item) => {
          const parts = item.split('-');
          return parts.length === 2 && /^\d{4}$/.test(parts[0]) && /^[1-4]$/.test(parts[1]);
        }),
    ),
  ]
    .map((item) => ({
      fullStr: item,
      year: item.split('-')[0],
      quarter: item.split('-')[1],
    }))
    .sort((a, b) => {
      if (a.year !== b.year) {
        return +a.year - +b.year;
      }
      return +a.quarter - +b.quarter;
    })
    .map((item) => {
      console.log('申报', item);

      return `${item.year}年${quarterMap[item.quarter]}`;
    })
    .join('、');
}
// 逾期申报处理
export function getSubmissionOverdueData(): CommonPendingInfo {
  const title = '逾期申报处理';
  const data: NotificationData = {
    title,
    type: 'rich_text',
    content: `
    <div class="flex items-center mb-4">
      <div class="flex-shrink-0">
        <div class="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
          <img src="https://unpkg.com/lucide-static@latest/icons/clipboard-list.svg" class="w-6 h-6 text-white" alt="" />
        </div>
      </div>
      <div class="flex-1 ml-4">
        <h4 class="text-base font-semibold">逾期申报待办</h4>
      </div>
    </div>
    <p>尊敬的经营者:</p>
    <p>您的
      <span style="color:#e53e3e">{{quarter}}</span> 由于未在税务规定时间内申报，导致申报逾期。
      为了避免税务处罚，请点击【立即登录】，登录后请立即与专属办理专员联系。
    </p>
    ${handleHtmlV2}
    ${complaintHtml}
    `,
    actions: [
      {
        label: '立即登录',
        key: 'open-login-dialog',
        type: 'primary',
        params: {
          intent: '逾期申报处理',
        },
      },
    ],
  };
  return {
    data,
    title,
  };
}
export function getAbnormalEnterpriseData(): CommonPendingInfo {
  const title = '其它企业异常待处理';
  const data: NotificationData = {
    title,
    type: 'rich_text',
    content: '您的税务业务已创建，等待审核。',
    actions: [
      {
        label: '查看详情',
        key: 'link-url',
        type: 'primary',
        url: 'https://www.baidu.com',
      },
      {
        label: '打开对话框',
        key: 'open-login-dialog',
        type: 'primary',
      },
      {
        label: '完成审核',
        key: 'complete-pending',
        type: 'default',
      },
    ],
  };
  return {
    data,
    title,
  };
}
export function getAuthenticationData(): CommonPendingInfo {
  const title = '电子税务局app实名认证待办';
  const data: NotificationData = {
    title,
    type: 'rich_text',
    content: `
    <div class="flex items-center mb-4">
      <div class="flex-shrink-0">
        <div class="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center">
          <img src="https://unpkg.com/lucide-static@latest/icons/user-check.svg" class="w-6 h-6 text-white" alt="" />
        </div>
      </div>
      <div class="flex-1 ml-4">
        <h4 class="text-base font-semibold">电子税务局app实名认证</h4>
      </div>
    </div>
    <div class='space-y-4 text-gray-700'>
      <p>请按以下步骤完成电子税务局app实名认证：</p>
      <div class="flex items-start space-x-3">
        <span class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-sm flex items-center justify-center font-bold">1</span>
        <span>打开电子税务局app完成账号密码登录</span>
      </div>
      <div class="flex items-start space-x-3">
        <span class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-sm flex items-center justify-center font-bold">2</span>
        <span>点击【我的】进入【账户中心】-【个人实名管理】页面，点击「提升等级」，按提示完成人脸核验，将等级提升至4级即可</span>
      </div>
      <div class="flex items-start space-x-3">
        <span class="flex-shrink-0 w-6 h-6 rounded-full bg-blue-500 text-white text-sm flex items-center justify-center font-bold">3</span>
        <span>提升完成后返回到此待办页面点击【立即登录】完成待办登录</span>
      </div>
    </div>`,
    actions: [
      {
        label: '立即登录',
        key: 'confirm-login-dialog',
        type: 'primary',
        params: {
          intent: '实名认证等级提升',
        },
      },
    ],
  };
  return {
    data,
    title,
  };
}
